export default "__VITE_ASSET__BTNoc5_S__"